import { ComponentProps } from 'react';

export const PartitionIcon = (props: ComponentProps<'svg'>) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.7214 21C5.7556 21 5.786 20.9868 5.8164 20.978C5.8962 20.9912 5.976 21 6.0596 21H19.8194C20.6288 21 21.3204 20.3617 21.499 19.4417L22.9582 11.9278C23.0722 11.3335 22.9506 10.7172 22.6238 10.2418C22.297 9.76644 21.8068 9.49353 21.2786 9.49353H21.271V8.62636C21.271 7.52589 20.4996 6.63231 19.5496 6.63231H12.0256C11.7596 6.63231 11.5012 6.50466 11.3188 6.27576L10.004 4.63827C9.681 4.2333 9.2212 4 8.7424 4H5.7214C4.7714 4 4 4.89358 4 5.99404V19.0016C4 20.102 4.7714 21 5.7214 21ZM22.0272 10.7965C22.2096 11.0606 22.278 11.4039 22.2134 11.7385L20.7542 19.2525C20.6554 19.7631 20.2678 20.124 19.8156 20.124H6.0596C5.767 20.124 5.4934 19.97 5.3072 19.7059C5.121 19.4417 5.0564 19.0984 5.121 18.7639L6.5802 11.2499C6.679 10.7393 7.0666 10.3783 7.5188 10.3783H21.2786C21.5712 10.3783 21.8448 10.528 22.0272 10.7965ZM5.7214 4.88037H8.7424C9.0084 4.88037 9.2668 5.00803 9.4454 5.23692L10.7602 6.87442C11.0832 7.27939 11.543 7.51269 12.0218 7.51269H19.5458C20.0778 7.51269 20.5072 8.0145 20.5072 8.62636V9.49353H7.5188C6.7094 9.49353 6.0178 10.1318 5.8392 11.0518L4.76 16.5981V5.99845C4.76 5.38219 5.1932 4.88037 5.7214 4.88037Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.4"
    />
  </svg>
);
